import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-grading-results-score',
  templateUrl: './header-column-grading-results.component.html',
  styleUrl: './header-column-grading-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnGradingResultsComponent extends HeaderColumnComponent {}
